import React, { useState } from "react";
import { Form } from "antd";
import Button from "@/common/elements/Button";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import useDialog from "@/hooks/useDialog";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useSelector } from "react-redux";

const JailIncidentClassViolationDetail = ({
  involvementsForm,
  majorOptionsAll,
  minorOptionsAll,
  classIOptionsAll,
  isFieldEnable,
}) => {
  const { showDialog } = useDialog();

  const onHandleViewCommentClassI = () => {
    const comment =
      involvementsForm?.getFieldValue("classIComments") ||
      "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  const onHandleViewCommentClassII = () => {
    const comment =
      involvementsForm?.getFieldValue("minorViolationsComments") ||
      "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  const onHandleViewCommentClassIII = () => {
    const comment =
      involvementsForm?.getFieldValue("majorViolationsComments") ||
      "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  const majorOptions = majorOptionsAll.filter((_, index) => index !== 0);
  const minorOptions = minorOptionsAll.filter((_, index) => index !== 0);
  const classIOptions = classIOptionsAll.filter((_, index) => index !== 0);

  return (
    <>
      {/* Class I Violations */}
      <StyledSectionHeading marginTop="20px">
        <span>Class I Violations</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        <Form.List name="jailIncidentsInvolvedInmateClassIViolation">
          {(fields, { add, remove }) => (
            <>
              {classIOptions.map((option, index) => {
                // check if mappingData already has this violation
                const mappingData =
                  involvementsForm.getFieldValue(
                    "jailIncidentsInvolvedInmateClassIViolation",
                  ) || [];

                const jailIncidentsInvolvedInmateId =
                  isNonEmptyVariable(mappingData) && mappingData?.length
                    ? mappingData?.[0]?.jailIncidentsInvolvedInmateId
                    : null;

                const existing = mappingData?.find(
                  (m) => m.jailIncidentsClassIViolationsId === option.value, // c
                );

                const isChecked = !!existing;

                return (
                  <StyledGridCol lg={8} key={option.value}>
                    <Form.Item valuePropName="checked">
                      <Checkbox
                        checked={isChecked}
                        onChange={(e) => {
                          if (e.target.checked) {
                            // add new object into array
                            add({
                              jailIncidentsInvolvedInmateId:
                                jailIncidentsInvolvedInmateId, // or dynamic
                              jailIncidentsClassIViolationsId: option.value,
                              jailIncidentsInvolvedInmateClassIViolationId:
                                null,
                            });
                          } else {
                            // remove existing object from array
                            const idx = fields.findIndex(
                              (f) =>
                                involvementsForm.getFieldValue([
                                  "jailIncidentsInvolvedInmateClassIViolation",
                                  f.name,
                                  "jailIncidentsClassIViolationsId",
                                ]) === option.value,
                            );
                            if (idx > -1) remove(idx);
                          }
                        }}
                        disabled={!isFieldEnable}
                      >
                        <p
                          style={{
                            color: isFieldEnable ? "#000" : "#999",
                          }}
                        >
                          {option.label}
                        </p>
                      </Checkbox>
                    </Form.Item>
                  </StyledGridCol>
                );
              })}
            </>
          )}
        </Form.List>
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={24} marginTop="12px">
          <FormItem label="Comments" name="classIComments">
            <TextField
              inputType="textarea"
              rows="3"
              disabled={!isFieldEnable}
            />
          </FormItem>
          <Button
            type="primary"
            color="primary"
            onClick={onHandleViewCommentClassI}
          >
            View Comments
          </Button>
        </StyledGridCol>
      </StyledGridRow>

      {/* Class II Violations */}
      <StyledSectionHeading marginTop="20px">
        <span>Class II Violations</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        <Form.List name="jailIncidentsInvolvedInmateMinorViolation">
          {(fields, { add, remove }) => (
            <>
              {minorOptions.map((option, index) => {
                // check if mappingData already has this violation
                const mappingData =
                  involvementsForm.getFieldValue(
                    "jailIncidentsInvolvedInmateMinorViolation",
                  ) || [];

                const jailIncidentsInvolvedInmateId =
                  isNonEmptyVariable(mappingData) && mappingData?.length
                    ? mappingData?.[0]?.jailIncidentsInvolvedInmateId
                    : null;

                const existing = mappingData?.find(
                  (m) => m.jailIncidentsMinorViolationsId === option.value,
                );

                const isChecked = !!existing;

                return (
                  <StyledGridCol lg={8} key={option.value}>
                    <Form.Item valuePropName="checked">
                      <Checkbox
                        checked={isChecked}
                        onChange={(e) => {
                          if (e.target.checked) {
                            // add new object into array
                            add({
                              jailIncidentsInvolvedInmateId:
                                jailIncidentsInvolvedInmateId, // or dynamic
                              jailIncidentsMinorViolationsId: option.value,
                              jailIncidentsInvolvedInmateMinorViolationId: null,
                            });
                          } else {
                            // remove existing object from array
                            const idx = fields.findIndex(
                              (f) =>
                                involvementsForm.getFieldValue([
                                  "jailIncidentsInvolvedInmateMinorViolation",
                                  f.name,
                                  "jailIncidentsMinorViolationsId",
                                ]) === option.value,
                            );
                            if (idx > -1) remove(idx);
                          }
                        }}
                        disabled={!isFieldEnable}
                      >
                        <p
                          style={{
                            color: isFieldEnable ? "#000" : "#999",
                          }}
                        >
                          {option.label}
                        </p>
                      </Checkbox>
                    </Form.Item>
                  </StyledGridCol>
                );
              })}
            </>
          )}
        </Form.List>
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={24} marginTop="12px">
          <FormItem label="Comments" name="minorViolationsComments">
            <TextField
              inputType="textarea"
              rows="3"
              disabled={!isFieldEnable}
            />
          </FormItem>
          <Button
            type="primary"
            color="primary"
            onClick={onHandleViewCommentClassII}
          >
            View Comments
          </Button>
        </StyledGridCol>
      </StyledGridRow>

      {/* Class III Violations */}
      <StyledSectionHeading marginTop="20px">
        <span>Class III Violations</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        <Form.List name="jailIncidentsInvolvedInmateMajorViolation">
          {(fields, { add, remove }) => (
            <>
              {majorOptions.map((option, index) => {
                // check if mappingData already has this violation
                const mappingData =
                  involvementsForm.getFieldValue(
                    "jailIncidentsInvolvedInmateMajorViolation",
                  ) || [];

                const jailIncidentsInvolvedInmateId =
                  isNonEmptyVariable(mappingData) && mappingData?.length
                    ? mappingData?.[0]?.jailIncidentsInvolvedInmateId
                    : null;

                const existing = mappingData?.find(
                  (m) => m.jailIncidentsMajorViolationsId === option.value,
                );

                const isChecked = !!existing;

                return (
                  <StyledGridCol lg={8} key={option.value}>
                    <Form.Item valuePropName="checked">
                      <Checkbox
                        checked={isChecked}
                        onChange={(e) => {
                          if (e.target.checked) {
                            // add new object into array
                            add({
                              jailIncidentsInvolvedInmateId:
                                jailIncidentsInvolvedInmateId, // or dynamic
                              jailIncidentsMajorViolationsId: option.value,
                              jailIncidentsInvolvedInmateMajorViolationId: null,
                            });
                          } else {
                            // remove existing object from array
                            const idx = fields.findIndex(
                              (f) =>
                                involvementsForm.getFieldValue([
                                  "jailIncidentsInvolvedInmateMajorViolation",
                                  f.name,
                                  "jailIncidentsMajorViolationsId",
                                ]) === option.value,
                            );
                            if (idx > -1) remove(idx);
                          }
                        }}
                        disabled={!isFieldEnable}
                      >
                        <p
                          style={{
                            color: isFieldEnable ? "#000" : "#999",
                          }}
                        >
                          {option.label}
                        </p>
                      </Checkbox>
                    </Form.Item>
                  </StyledGridCol>
                );
              })}
            </>
          )}
        </Form.List>
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={24} marginTop="12px">
          <FormItem label="Comments" name="majorViolationsComments">
            <TextField
              inputType="textarea"
              rows="3"
              disabled={!isFieldEnable}
            />
          </FormItem>
          <Button
            type="primary"
            color="primary"
            onClick={onHandleViewCommentClassIII}
          >
            View Comments
          </Button>
        </StyledGridCol>
      </StyledGridRow>
    </>
  );
};

export default JailIncidentClassViolationDetail;
